import React, { useState,useEffect } from 'react';
import './CheckOut.css';
import Header from '../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useAuth from '../../../customHooks/useAuth';
import Select from 'react-select';
import axios from 'axios';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';


export default function CheckOut() {
  const location = useLocation();
  const navigate = useNavigate();

  // Refresh Handle
  useAuth();

  const userId = localStorage.getItem("user_id");
  const bookedRooms = location.state?.bookedRooms || [];

  const bookingId = location.state?.bookingId || '';
  const hotelId = location.state?.hotelId || '';
  const hotelAddress = location.state?.hotelAddress || "";
  const hotelName = location.state?.hotelName || '';
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const status = location.state?.status || "";
  const activeTab = location.state?.activeTab || "";
  const booking_code = location.state?.booking_code || "";

 

  const [formData, setFormData] = useState({
    comment: '',
    rooms: [], // Changed to an array to handle multiple selections
  });

    // Move to bookings page if the hotelId and bookingId is not Present  
  useEffect(()=>{
    if(bookingId==="" || hotelId===""){
        navigate("/booking");
    }
  },[hotelId,bookingId,navigate]);

  // Error Handling
  const [errors, setErrors] = useState({});

  // Loader
  const [isLoading,setIsLoading] = useState(false);

  // Convert rooms to options for react-select
  const roomOptions = bookedRooms
  .filter((room) => room.room_number) // Filter out rooms without a room number
  .map((room) => ({
    value: room.id,
    label: `${room.room_number}`,
  }));


  // Handle Change  
  const handleChange = (selectedRooms) => {
    const roomIds = selectedRooms.map((room) => room.value);
    setFormData((prevState) => ({
      ...prevState,
      rooms: roomIds, // Update selected room IDs
    }));
    validateField('rooms', roomIds);
  };

  const handleCommentChange = (e)=>{
      const { name, value } = e.target;
      
      setFormData((prevState) => ({
          ...prevState,
          [name]: value,
      }));
      validateField(name,value);

  }

  //  For Handle Change Validations  
  const validateField = (field, value) => {
      const newErrors = { ...errors };
      switch (field) {
      // case 'comment':
      //     if (!value.trim()) {
      //     newErrors.comment = 'Comments Required';
      //     } else {
      //     newErrors.comment = '';
      //     }
      //     break;

      case 'rooms':
          if (!value.length) {
          newErrors.rooms = 'At least one room is required';
          } else {
          newErrors.rooms = '';
          }
          break;

      default:
          break;
      }
      setErrors(newErrors);
  };

  // Submitting Form Validations
  const validateForm = () => {
    const validationsErrors = {};
    // if (!formData.comment) {
    //   validationsErrors.comment = 'Comments Required';
    // }
    if (!formData.rooms.length) {
      validationsErrors.rooms = 'At least one room is required';
    }
    setErrors(validationsErrors);
    return Object.keys(validationsErrors).length === 0;
  };

    // Submit Handler  
  const handleSubmit = async() => {
    try {
        if (!validateForm()) {
          // console.log('Please Validate Form!!');
          return;
        }
        setIsLoading(true);
        // console.log('FormData : ', formData);
        const passData = {
          comment : formData.comment,
          booked_room_ids: formData.rooms, // Pass the selected room IDs
        };


        const currentUser = await getCurrentUser();

        function findMatchedRooms(bookedRooms, usersData) {
          const contact = usersData.contact;
          const matchedRooms = bookedRooms.filter((room)=>{
            // Check if guests are null or an empty array, and skip the room if true
            if (!room.guests || room.guests.length === 0) {
              return false; // Skip this room
            }
            const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
            if(matchedGuest) {
              return true; //
            }
            else{
              return false;
            }
          });
          return matchedRooms;
        }        

        const usersData = currentUser;  
        const matchedRooms = findMatchedRooms(bookedRooms, usersData);
        if(matchedRooms.length<=0){
          // console.log("Booking is not Present ");
          return;
        }
        // console.log("MAtched Rooms : " + matchedRooms[0].id);

 
        // Handle further logic here, such as API calls with passData
        try{
          const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/checkout-request/`,passData);

          // console.log("Success : ",response.data);
          toast.success("CheckOut Request Created Successfully");
          navigate("/bookings",{state : {activeRequests : "requests"}});
        }
        catch(error){
          toast.error(error?.response?.data?.message || "Some Error Occured");
          console.log(error);  
        }

    }catch (error) {
      console.log(error);
    }
    finally{
      setIsLoading(false);
    }
  };

  return (
    <>
      {
        isLoading && <PageLoader/>
      }
      <div className='checkout'>
        <Header title='Checkout'
          hotelName = {hotelName}
          hotelAddress = {hotelAddress}
          checkInDate = {checkInDate}
          checkOutDate = {checkOutDate}
          status = {status}
          activeTab = {activeTab}
          hotelId = {hotelId}
          bookingId = {bookingId}
          movetoHotel = "movetoHotel"
          booking_code = {booking_code}
        />

        <div className='checkout-data'>
          <div className='checkout-fields'>
            <h4>Additional Comments</h4>
            <div className='checkout-comment'>
              <textarea
                rows='4'
                cols='10'
                name='comment'
                onChange={handleCommentChange}
              ></textarea>
            </div>
            {errors.comment && <span className='error-message'>{errors.comment}</span>}
          </div>

          <div className='checkout-fields'>
            <h4>Service Room</h4>
            <div className='checkout-roomSelect'>
              <Select
                isMulti
                name='rooms'
                options={roomOptions}
                classNamePrefix='select'
                onChange={handleChange}
                value={roomOptions.filter((option) =>
                  formData.rooms.includes(option.value)
                )}
                menuPlacement="top" // This places the dropdown above the input
              />
              <button onClick={handleSubmit}>Checkout</button>
            </div>
            {errors.rooms && <span className='error-message'>{errors.rooms}</span>}
          </div>
        </div>
      </div>
    </>
  );
}
